import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { Alert } from 'selenium-webdriver';
import { CommonService } from 'src/app/Service/Common.service';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { ReplectRoleMemberModel } from 'src/app/ViewModel/RoleMemberMappedModel';

@Component({
  selector: 'app-replace-member',
  templateUrl: './replace-member.component.html',
  styleUrls: ['./replace-member.component.css']
})
export class ReplaceMemberComponent implements OnInit {
  public Unsubscribes: Subscription[] = [];
  ReplacementRequiredMembers: ReplectRoleMemberModel[];
  RoleMembersUpdated: any[];
  IsMemberRemoved: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public _data: any, public dialogRef: MatDialogRef<ReplaceMemberComponent>, public commonService: CommonService, private _projInfoService: ProjectInfoService) { }

  ngOnInit(): void {
    this.ReplacementRequiredMembers = this._data['ReplacementRequiredMembers'];
    this.RoleMembersUpdated = this._data['RoleMembersUpdated'];
    this.IsMemberRemoved = this._data['IsMemberRemoved'];

    this.ReplacementRequiredMembers.forEach(async data => {
      data.ReplacementMembers = [];
      this.Unsubscribes.push(this._projInfoService.getProjectMembersByRole({
        projectId: data.projectId,
        groupId: data.groupId,
        roleId: data.role_Id
      }).subscribe(res => {
        if (this.IsMemberRemoved) {
          data.ReplacementMembers = res.filter(({
            memberId: ActualMemberId
          }) => this.RoleMembersUpdated.every(({
            memberId: ReplaceMemberId
          }) => {
            return (ActualMemberId != ReplaceMemberId)
          }));
        } else {
          data.ReplacementMembers = res.filter(({
            memberId: ActualMemberId
          }) => this.RoleMembersUpdated.filter(x => !x.isCheck && x.roleId == data.role_Id).every(({
            memberId: ReplaceMemberId
          }) => {
            return (ActualMemberId != ReplaceMemberId)
          }));
        }
      }));
    })
  }

  isValid(): boolean {
    return this.ReplacementRequiredMembers.some(o => o.replaceMemberId == 0 || o.replaceMemberId == -2)
  }

  closeDialog() {
    this.dialogRef.close();
  }

  DelegateMember() {
    this.dialogRef.close(this._data['RoleMembersUpdated']);
  }

  ngOnDestroy(): void {
    this.Unsubscribes.forEach(x => x.unsubscribe());
  }

  UpdateValueChange(event: any, container: any) {
    container.replaceMemberId = event.value;
    this.RoleMembersUpdated.filter(x => x.memberId == container.member_Id && x.roleId == container.role_Id).map(y => y.delegateMemberId = (event.value == '0' || event.value == '-2') ? 0 : event.value);
  }
}
